import React, { Component } from 'react';
import {
    FlatList,
    ScrollView,
    View,
    TouchableOpacity,
    ActivityIndicator
} from 'react-native';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';

import { Creators as produtoSelecionadoActions } from '../../store/ducks/produto-selecionado';
import { Creators as produtosActions } from '../../store/ducks/produtos';

import Text from '../../react-component/textComponent';

import EmptyState from './emptyState';

import styles from './styles';

class ListaDepartamento extends Component {
    state = {
        list: [],
        loading: true,
        selectedItem: ''
    };

    componentDidMount() {
        this.loadProdutoDepartamento();
    }

    componentDidUpdate(prevProps) {
        const { query, list = {}, sameSearch } = this.props;
        var different = false;

        if (prevProps.list && list) {
            different = this.checkIsDifferent(prevProps.list, list);
        }

        if (
            query !== prevProps.query ||
            (different && sameSearch) ||
            (different && query !== prevProps.query)
        ) {
            this.loadProdutoDepartamento();
        }
    }

    loadProdutoDepartamento = async () => {
        await this.props.loadDepartamentoList();

        const { query, idDepartamento, clearProdutos, list } = this.props;

        if (list.length === 0) {
            clearProdutos();
        }

        this.setState({ ...this.state, list, loading: false });

        if (query || idDepartamento || !isMobile) {
            if (list.length > 0) this.showDetalhe(list[0]);
        }
    };

    checkIsDifferent = (listA, listB) => {
        var listDispsA = [],
            listDispsB = [];

        for (let i = 0; i < listB.length; i++) {
            listDispsB.push(listB[i].idDepartamento);
        }

        for (let i = 0; i < listA.length; i++) {
            listDispsA.push(listA[i].idDepartamento);
        }

        for (let i = 0; i < listDispsA.length; i++) {
            if (listDispsB.indexOf(listDispsA[i]) === -1) {
                return true;
            }
        }

        return false;
    };

    showDetalhe = (item) => {
        const { query, clearProdutoSelecionado } = this.props;
        const { idDepartamento } = item;

        clearProdutoSelecionado();

        this.setState({ ...this.state, selectedItem: item });
        this.props.onSelect(idDepartamento, query);
    };

    renderItem = ({ item }) => {
        const { dsDepartamento, countProdutos, idDepartamento } = item,
            { selectedItem } = this.state,
            selectedItemStyle =
                selectedItem.idDepartamento === idDepartamento
                    ? styles.selectedItem
                    : null;

        return (
            <TouchableOpacity
                style={[selectedItemStyle, styles.itemList]}
                onPress={() => this.showDetalhe(item)}
            >
                <View style={styles.lineContent}>
                    <Text style={styles.itemTitle}>{dsDepartamento}</Text>
                </View>

                <View style={styles.lineContent}>
                    <Text style={styles.itemInfo}>
                        {countProdutos}
                        {countProdutos > 1 ? ' produtos' : ' produto'}
                    </Text>
                </View>
            </TouchableOpacity>
        );
    };

    renderList = () => {
        const { list } = this.props;

        return (
            <ScrollView>
                <FlatList
                    data={list}
                    renderItem={this.renderItem}
                    ListEmptyComponent={() => this.emptyState()}
                    keyExtractor={(item, index) =>
                        `departamento-${item.idDepartamento}-${index}`
                    }
                />
            </ScrollView>
        );
    };

    render() {
        const { loading } = this.state;

        return (
            <View style={styles.container}>
                {loading ? (
                    <ActivityIndicator style={styles.loading} size="large" />
                ) : (
                    this.renderList()
                )}
            </View>
        );
    }

    emptyState = () => {
        return <EmptyState />;
    };
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { ...produtoSelecionadoActions, ...produtosActions },
        dispatch
    );

export default connect(null, mapDispatchToProps)(ListaDepartamento);
